const CodeColourList = () =>
  import(/* webpackChunkName: "admin" */ "./pages/ListPage.vue");
const CodeColourDetail = () =>
  import(/* webpackChunkName: "admin" */ "./pages/FormPage.vue");
const CodeColourIndex = () =>
  import(/* webpackChunkName: "admin" */ "./pages/IndexPage.vue");

export default [
  {
    path: "/code_colour",
    component: CodeColourIndex,
    redirect: "/code_colour/list",
    name: "code_colour",
    children: [
      {
        path: "list",
        component: CodeColourList,
        name: "code_colour.list",
      },
      {
        path: "create",
        component: CodeColourDetail,
        name: "code_colour.create",
        props: { create: true },
      },
      {
        path: "edit/:id",
        component: CodeColourDetail,
        name: "code_colour.edit",
        props: { create: false },
      },
    ],
  },
];
